export class TNCPermission {
  public TNC_Admin: boolean = false;
  public TNC_Admin_Unit  : boolean = false;
  public TNC_Approver: boolean = false;
  public TNC_Approver_Unit: boolean = false;
  public TNC_Add: boolean = false;
  public TNC_Add_Unit: boolean = false;
  public TNC_View_Unit: boolean = false;
  public TNC_View: boolean = false;
}
